<template>
  <v-container>
    <page-header :title="lang.alphaNumeric" :info="lang.alphaNumericInfo(id)" />
    <grid :items="items" :headers="headers" />
    <div hidden v-if="id" v-html="lang.alphaNumericInfo(id)" :class="['meta-description']" />
  </v-container>
</template>
<script>
import lang from '../helpers/lang'
import methods from '../helpers/methods'
import data from '../helpers/data'

export default {
  name: 'alphanumeric-id',
  mixins: [
    data,
    methods
  ],
  data () {
    return {
      lang,
      id: null
    }
  },
  watch: {
    /**
     * route.params.id watcher
     */
    '$route.params.id' () {
      this.setData()
    }
  },
  mounted () {
    this.setData()
  },
  methods: {
    onMounted () {
      this.setData()
    },
    /**
     * Get the page data from the API
     * @method setData
     * @return {void}
     */
    setData () {
      this.id = encodeURIComponent(this.$route.params.id)
      this.getTabularData('alphanumeric', this.id, 'id', () => {
        this.setLastBreadcrumbsItemText(this.id)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/alphanumeric-id.vue